import { BookmarkIcon, Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetClassesQuery } from "../../hooks/useGetClassesQuery";
import { setClassData } from "../../redux/slices/school/classes";
import { routes } from "../../routes";
import { updateClass } from "../../services/school/class/updateClass";
import { ClassType } from "../../types/Class";
import { Key_classes, PAGE_NUMBER, PAGE_SIZE } from "../../utils/constants";
import { Regimes } from "../../utils/codes";
import { deleteClass } from "../../services/school/class/deleteClass";

const columnNamesMap: { [key: string]: string } = {
  description: 'Turma',
  academicYear: 'Ano Académico',
  level: 'Nível',
  semester: 'Semestre',
  regimeName: 'Regime',
};

const mapRegime = (regimeValue: number | undefined): string => {
  const regime = Regimes.find(r => r.id === String(regimeValue));
  return regime ? regime.description : String(regimeValue) || '-';
};

export const Classes = () => {
  const [currentPage, setCurrentPage] = useState(PAGE_NUMBER);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetClassesQuery({
    PageNumber: currentPage, PageSize: pageSize, SearchTerm: searchTerm,
    IdAcademicYear: '',
    IdCourse: '',
    //  Regime:'',
    // Semester:'',
    // Level:'',



  });
  const mutationDeleteClass = useMutation(deleteClass, {
    onSuccess: () => {
      queryClient.invalidateQueries(Key_classes);
      toast.success('Turma eliminada');
    },
    onError: () => {
      toast.error("Erro ao eliminar a turma.")
    }
  });

  const mappedItems = data?.items?.map((item: ClassType) => ({
    ...item,
    regimeName: mapRegime(item.regime)
  })) || [];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    setCurrentPage(PAGE_NUMBER);
  };

  const handleSearch = (term: string) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };
  const handleClickCreate = (event: any): void => {
    navigate(routes.createClass)
  }
  const handleEdit = (_class: ClassType) => {
    dispatch(setClassData(_class));
    navigate(routes.updateClass)
  }; 
  const handleDelete = (_class: ClassType) => {
    _class.status = false;
    mutationDeleteClass.mutateAsync({ id: _class.id! })
  };
  const handleLinkTeacherAndSubjects = (_class: ClassType) => {
    dispatch(setClassData(_class));
    navigate(routes.assignTeacherClassesSubjects)
  };

  const handleManageStudents = (_class: ClassType) => {
    dispatch(setClassData(_class));
    navigate(routes.manageClassStudents)
  };
  const handleManageSchedule = (_class: ClassType) => {
    dispatch(setClassData(_class));
    navigate(routes.manageSchedule)
  };
  const options = data?.items.map(() => [
    {
      label: 'Editar',
      onClick: (_class: ClassType) => handleEdit(_class),
      icon: <Pencil1Icon />
    },
    {
      label: 'Eliminar',
      onClick: (_class: ClassType) => handleDelete(_class),
      icon: <TrashIcon />
    },
    {
      label: 'Gerir estudantes',
      onClick: (_class: ClassType) => handleManageStudents(_class),
      icon: <BookmarkIcon />
    },
    {
      label: 'Vincular docente X disciplina',
      onClick: (_class: ClassType) => handleLinkTeacherAndSubjects(_class),
      icon: <BookmarkIcon />
    },
    {
      label: 'Gerir horário',
      onClick: (_class: ClassType) => handleManageSchedule(_class),
      icon: <BookmarkIcon />
    }
  ]) || [];
  return (
    <Lists
      status={status}
      TableComponent={() =>
           <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={mappedItems}
            options={options}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange} 
            onSearch={handleSearch}
            search={searchTerm}
            totalItems={data?.totalItems || 0}
          />
      }
      handleClickCreate={handleClickCreate}
    />
  );
}
